import SubdirectoryArrowRightIcon from "@material-ui/icons/SubdirectoryArrowRight";

import * as theme from "../theme";
const GroupNavs = ({
  text,
  isopen,
  handleGroupTabsClick,
  handleGroupBuildingTabClick,
  isSubGroup = false,
  display = "flex",
  htmlid
}) => {
  return (
    <>
      {!isSubGroup && (
        <div
          style={{
            minHeight: "4vh",
            width: "100%",
            display: display,
            alignItems: "center",
            fontFamily: "GibsonLight",
            marginBottom: "3px",
          }}
          id={htmlid}
          onClick={() => handleGroupTabsClick()}
        >
          <>
            <div
              style={{
                height: "100%",
                display: display,
                alignItems: "center",
                paddingBottom: "2px",
              }}
            >
              <SubdirectoryArrowRightIcon
                style={{
                  color: theme.COLORS.primary_navyblue,
                  fontSize: "1.6vmin",
                }}
              ></SubdirectoryArrowRightIcon>
            </div>

            <div
              style={{
                height: "100%",
                display: display,
                alignItems: "center",
                marginLeft: "3px",
                paddingLeft: "7px",
                paddingRight: "7px",
                backgroundColor: isopen
                  ? theme.COLORS.primary_navyblue
                  : "inherit",
                borderRadius: 3,
                width:"100%"
              }}
            >
              {text}
            </div>
          </>
        </div>
      )}

      {isSubGroup && (
        <div
          style={{
            minHeight: "4vh",
            width: "100%",
            display: display,
            alignItems: "center",
            fontFamily: "GibsonLight",
            marginBottom: "3px",
          }}
          id={htmlid}
          onClick={() => handleGroupBuildingTabClick()}
        >
          <>
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                paddingBottom: "2px",
                marginLeft: "20px",
              }}
              onClick={() => handleGroupBuildingTabClick()}
            >
              <SubdirectoryArrowRightIcon
                style={{
                  color: theme.COLORS.primary_navyblue,
                  fontSize: "1.6vmin",
                }}
              ></SubdirectoryArrowRightIcon>
            </div>

            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                marginLeft: "4px",
                paddingLeft: "7px",
                paddingRight: "7px",
                backgroundColor: isopen
                  ? theme.COLORS.primary_navyblue
                  : "inherit",
                borderRadius: 3,
              }}
            >
              {text}
            </div>
          </>
        </div>
      )}
    </>
  );
};

export default GroupNavs;
